import HealthRecordForm from "../../components/forms/healthRecordForm";
import HealthRecordTable from "../../components/tables/healthRecordTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, healthRecordCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const HealthRecords = () => {
  const { selectedChild } = useChild();
  const { items: healthRecordData, addItem, updateItem, deleteItem, loading, error } = useFirestore("healthRecords", selectedChild?.id);

  const handleAddHealthRecord = async (record) => {
    try {
      await addItem({ ...record, childId: selectedChild?.id });
    } catch (err) {
      console.error("Error adding health record:", err);
    }
  };

  const handleExport = () => {
    exportToCSV(healthRecordData, `health-records-${selectedChild?.name || "export"}.csv`, healthRecordCSVColumns);
  };

  const handleExportPDF = () => {
    exportSectionPDF(healthRecordData, `health-records-${selectedChild?.name || "export"}.pdf`, healthRecordCSVColumns, "Health Records", selectedChild?.name || "");
  };

  return (
    <div className="card h-100" id="health-records">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title mb-0">🏥 Health Records</h5>
          <div className="d-flex gap-1">
            <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
            <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <HealthRecordForm onAdd={handleAddHealthRecord} />
        {loading ? (
          <LoadingState message="Loading health records..." />
        ) : healthRecordData.length > 0 ? (
          <HealthRecordTable data={healthRecordData} onUpdate={updateItem} onDelete={deleteItem} />
        ) : (
          <EmptyState
            icon="📋"
            heading="No health records yet"
            message="Start building your child's health history — invaluable at any appointment."
          />
        )}
      </div>
    </div>
  );
};

export default HealthRecords;
